import { jsx as e, jsxs as m } from "react/jsx-runtime";
import { Skeleton as h, FormControl as f, InputLabel as b, Select as g, MenuItem as o } from "@mui/material";
import "../../queries/message/index.js";
import "../../queries/contact/index.js";
import "../../queries/calendars/index.js";
import "../../index-DNTqwtVt.js";
import { student as v } from "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import "../../queries/files/index.js";
import "../../queries/attendance/index.js";
import "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import "../../queries/courses/index.js";
import "../../queries/password/index.js";
function R({
  studentId: l,
  year: a,
  onChange: p,
  includeSpecial: u = !1,
  specialLabel: d = "All"
}) {
  const { data: n, isPending: s } = new v.YearsAndClasses({ studentId: Number(l) }).ToQuery(), i = (/* @__PURE__ */ new Date()).getFullYear();
  if (s)
    return /* @__PURE__ */ e(h, { variant: "rectangular", width: 150, height: 56 });
  if (!n)
    return null;
  const { years: t } = n;
  return /* @__PURE__ */ m(f, { sx: { minWidth: 150 }, children: [
    /* @__PURE__ */ e(b, { id: "year-label", children: "Year" }),
    /* @__PURE__ */ m(
      g,
      {
        labelId: "year-label",
        id: "year",
        value: a,
        label: "Year",
        onChange: (r) => p(Number(r.target.value)),
        children: [
          u && /* @__PURE__ */ e(o, { value: 0, children: d }),
          (t == null ? void 0 : t.indexOf(i)) < 0 && /* @__PURE__ */ e(o, { value: i, children: i }),
          t == null ? void 0 : t.sort((r, c) => c - r).map((r) => /* @__PURE__ */ e(o, { value: r, children: r }, r))
        ]
      }
    )
  ] });
}
export {
  R as default
};
//# sourceMappingURL=StudentYears.js.map
